import { Field, Form } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Col, Container, ModalFooter, Row } from 'reactstrap';
import { actions } from '../../../context';
import FieldTitle from '../../Forms/FieldTitle';

const PartnerForm = ({ toggle, refresh, partner = {}, isNew = false }) => {
    const dispatch = useDispatch();
    let history = useHistory();
    const sumbit = async (vals) => {
        if (isNew === true) {
            dispatch(actions.partner.createNewPartner({ ...vals })).then(
                (res) => {
                    if (res) {
                        toggle();
                        refresh();
                        history.push('/admin/partners/' + res.data);
                    }
                }
            );
        }
    };
    return (
        <Form
            initialValues={partner}
            onSubmit={sumbit}
            render={({ handleSubmit, form, values, pristine }) => (
                <form onSubmit={handleSubmit}>
                    <Container>
                        <Row className="mb-4">
                            <Col>
                                <FieldTitle title="Partner Name" required />
                                <Field
                                    className="p-2 rounded w-75 border"
                                    component="input"
                                    name="name"
                                    placeholder="Name"
                                    required
                                />
                            </Col>
                        </Row>
                    </Container>
                    <ModalFooter>
                        <Button color="danger" onClick={toggle}>
                            Cancel
                        </Button>
                        <Button
                            color="success"
                            disabled={pristine}
                            type="submit">
                            Submit
                        </Button>
                    </ModalFooter>
                </form>
            )}
        />
    );
};

export default PartnerForm;
